import type { ReactNode } from 'react';
import Typography from '@classify/react-core-components/Typography';

interface Props {
  children: ReactNode;
}

const CourseTitle = ({ children }: Props) => (
  <Typography variant="h2" component="h1" sx={{ pb: 2, pt: { xs: 2, md: 0 } }} id="course-title">
    {children}
  </Typography>
);

export default CourseTitle;
